import { render, staticRenderFns } from "./InspectionContainer.vue?vue&type=template&id=34ef13ec&"
import script from "./InspectionContainer.vue?vue&type=script&lang=js&"
export * from "./InspectionContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34ef13ec')) {
      api.createRecord('34ef13ec', component.options)
    } else {
      api.reload('34ef13ec', component.options)
    }
    module.hot.accept("./InspectionContainer.vue?vue&type=template&id=34ef13ec&", function () {
      api.rerender('34ef13ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Inspection/InspectionContainer.vue"
export default component.exports